export const INSTAGRAM_PROFILE = {
  handle: "@professor__johncamp",
  url: "https://www.instagram.com/professor__johncamp/",
};

export const FIELD_UPDATES = [
  {
    id: "cannes-interview-reel",
    category: "Interview",
    date: "May 15, 2026",
    title: "Cannes, France — Interview Series",
    summary: "Conversations from Cannes on health, performance and the future of personalized care.",
    image: "/updates/cannes-interview-reel.jpg",
    imageAlt: "Professor John Camp on the red carpet at Cineum Cannes from Instagram",
    href: "https://www.instagram.com/reel/DYW0GDvRXTr/",
  },
  {
    id: "olympia-podcast-stage",
    category: "Appearance",
    date: "August 3, 2026",
    title: "From Cannes to the Olympia Podcast Stage",
    summary: "A conversation on AI, clinical intelligence, genomics, wearables and proactive care.",
    image: "/updates/olympia-podcast-stage.jpg",
    imageAlt: "Professor John Camp Olympia Podcast Stage announcement from Instagram",
    href: "https://www.instagram.com/p/DbmjUc6R9UM/",
  },
  {
    id: "fitexpo-olympia-stage",
    category: "Upcoming",
    date: "August 4, 2026",
    title: "Olympia + Anaheim Fit Expo",
    summary: "Speaking on both podcast stages about a more proactive and personalized healthcare model.",
    image: "/updates/fitexpo-olympia-stage.jpg",
    imageAlt: "Professor John Camp Anaheim Fit Expo and Olympia Podcast Stage announcement from Instagram",
    href: "https://www.instagram.com/p/DbovOKjxLAE/",
  },
];

export const EDUCATION_UPDATES = [
  {
    id: "insulin-resistance",
    category: "Metabolic",
    title: "Insulin Resistance & Metabolic Health",
    image: "https://static.prod-images.emergentagent.com/jobs/c8a65975-d751-4172-9e88-294ec65cc742/images/df77be67313bdbdd64611eb5a89ce32b58f307d1ed6e95ef42ff6332f052f5b5.jpeg",
    imageAlt: "Metabolic health signals visualized across the body",
    href: "/evidence/insulin-resistance",
  },
  {
    id: "wearables-hrv-clinical",
    category: "Wearables",
    title: "HRV, Sleep & Wearable Data",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_integrated-matrix/artifacts/76nndxbn_futuristic_close-up_of_a_smartwatch_on_a_wrist_displaying_he.webp",
    imageAlt: "Smartwatch showing continuous heart-rate and HRV measurements",
    href: "/evidence/wearables-hrv-clinical",
  },
  {
    id: "biological-age-epigenetic-clocks",
    category: "Longevity",
    title: "Biological Age & Epigenetic Clocks",
    image: "https://static.prod-images.emergentagent.com/jobs/c8a65975-d751-4172-9e88-294ec65cc742/images/e04343809871ad79f91be68f718fb2037e2f1518daf4f37f06c38c3d7d9fffbc.jpeg",
    imageAlt: "Biological age visualized through DNA, vascular and physical reserve signals",
    href: "/evidence/biological-age-epigenetic-clocks",
  },
];